import React from 'react';

import {Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';


function Navigation() {
  return (
    <>  
    <Navbar expand='md'>    
    <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-md`} />
    <Navbar.Offcanvas
    id={`offcanvasNavbar-expand-md`}
    aria-labelledby={`offcanvasNavbarLabel-expand-md`}
    placement="end"
    >
    <Offcanvas.Header closeButton>
    <Offcanvas.Title id={`offcanvasNavbarLabel-expand-md`}>
    Offcanvas
    </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
    <Nav  className=" flex-grow-1 pe-3">
    <Nav.Link> <Link to='/fair'>Fair</Link> </Nav.Link>
    <Nav.Link><Link to='/programming'>Programming</Link></Nav.Link>
    <Nav.Link><Link to='/focus'>FOCUS photo l.a.</Link></Nav.Link>
    <Nav.Link><Link to='/international'>International Gallery Guide</Link></Nav.Link>
    <Nav.Link><Link to='/about'>About</Link></Nav.Link> 
    </Nav>
    <Nav >
    <Nav.Link className='signup-btn'> <Link to='/signup'>Sign Up</Link> </Nav.Link>
    <Nav.Link className='login-btn'> <Link to='/login'>Login</Link> </Nav.Link>
    </Nav>
    </Offcanvas.Body>
    </Navbar.Offcanvas>
 
    </Navbar>
    
    </>
    );
  }
  
  export default Navigation;